// extracted by mini-css-extract-plugin
export default {"wrapper":"aC-z","viewport":"bC-z","container":"cC-z","slide":"dC-z"};